export enum PagingEnum {
  DEFAULT_PAGE_INDEX = 1,
  DEFAULT_PAGE_SIZE = 25,
  PAGE_SIZE_1 = 50,
  PAGE_SIZE_2 = 100,
}
